import { RouteConfig } from "vue-router";
import { UserState } from "@/store/modules/auth/interfaces";

export const recruiter_ai_assessments: RouteConfig = {
  // Create Assessment Route (/assessments/ai-assessments)

  path: "ai-assessments",
  name: "ai-assessments",
  component: () =>
    import("@/views/recruiter/ai_assessment/AiAssessmentsWrapper.vue"),
  meta: {
    user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
  },
  children: [
    {
      path: "",
      name: "ai-assessments-home",
      component: () =>
        import("@/views/recruiter/ai_assessment/AiAssessments.vue"),
      meta: {
        user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
      }
    },
    // AI Assessment Creation Route (/assessments/ai-create)
    {
      path: "create",
      name: "create-ai-assessment",
      component: () =>
        import("@/views/recruiter/ai_assessment/AIAssessmentCreation.vue"),
      meta: {
        user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
      }
    },
    {
      path: "edit/:id",
      name: "edit-ai-assessment",
      component: () =>
        import("@/views/recruiter/ai_assessment/EditAssessment.vue"),
      meta: {
        user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
      }
    }
  ]
};
